import { render, staticRenderFns } from "./OuTuService.vue?vue&type=template&id=8cad34d0&scoped=true"
import script from "./OuTuService.vue?vue&type=script&lang=js"
export * from "./OuTuService.vue?vue&type=script&lang=js"
import style0 from "./OuTuService.vue?vue&type=style&index=0&id=8cad34d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cad34d0",
  null
  
)

export default component.exports